exports.components = {
  "component---src-components-templates-project-tsx": () => import("./../../../src/components/templates/Project.tsx" /* webpackChunkName: "component---src-components-templates-project-tsx" */),
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

